import * as moment from 'moment-timezone';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { GasprecioService } from 'src/app/modules/gasprecio/services/gasprecio.service';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';
import { Router, Event as NavigationEvent, NavigationEnd } from '@angular/router';
import Highcharts from 'highcharts';

@Component({
  selector: 'app-chart-earning',
  templateUrl: './chart-earning.component.html',
  styleUrls: ['./chart-earning.component.scss']
})
export class ChartEarningComponent implements OnInit, OnDestroy {

  @Input() station: any = false;
  @Input() v2: any = false;
  date: any;
  days = 30;
  days$!: Subscription;
  earning: any;
  earningDif;
  fullData;
  event$!: Subscription;
  Highcharts: typeof Highcharts = Highcharts;
  idGroup = '60afa99655f4ee369d1df409';
  idGroup$!: Subscription;
  idStation: string;
  idStation$!: Subscription;
  importants;
  importants$: Subscription;
  months = 12;
  months$!: Subscription;
  period = 'day';
  period$!: Subscription;
  productType = 'regular';
  productType$!: Subscription;
  reqst = 0;
  private loadTimer: ReturnType<typeof setTimeout>;
  private request$: Subscription;
  rol;
  route;
  selectedCluster;
  selectedCluster$!: Subscription;
  selectedCluster2;
  selectedCluster2$!: Subscription;
  selectedCluster3;
  selectedCluster3$!: Subscription;
  selectedCluster4;
  selectedCluster4$!: Subscription;
  showRendichicas = false;
  showScale = true;
  showColor = false;
  changeColor = false;
  showTooltip = true;
  weeks = 12;
  weeks$!: Subscription;
  zoneSelected = null;
  zoneSelected$: Subscription;
  chartOptions: Highcharts.Options = {
    credits: {
      enabled: false
    },
    chart: {
      type: 'column'
    },
    title: {
      text: `Utilidad Bruta`,
      style: {
        fontSize: '0'
      }
    },
    xAxis: {
      categories: [],
      gridLineWidth: 1,
      gridLineDashStyle: 'LongDash',
      title: {
        text: 'Fecha',
        style: {
          fontSize: '0'
        }
      },
      labels: {
        style: {
          fontSize: '11px',
        },
        rotation: -60,
        y: 14
      }
    },
    yAxis: [
      {
        title: {
          text: 'Utilidad Bruta',
          style: {
            fontSize: '0'
          }
        },
        labels: {
          format: '$ {value:,.0f}',
          style: {
            fontSize: '11px'
          }
        },
        tickAmount: 10,
        gridLineDashStyle: 'LongDash'
      }
    ],
    legend: {
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'top',
      itemDistance: 10,
      y: 1,
      padding: 1,
      itemMarginTop: 1,
      itemMarginBottom: 1,
      itemHoverStyle: {
        color: '#00E07B',
      }
    },
    tooltip: {
      split: true,
    },
    plotOptions: {
      column: {
        animation: {
          duration: 1000
        },
        stacking: 'normal'
      }
    },
    exporting: {
      filename: `Utilidad Bruta`,
      sourceWidth: 1200,
      sourceHeight: 800,
    },
    navigation: {
      buttonOptions: {
        align: 'right',
        y: -10
      }
    },
    series: []
  };

  constructor(
    private gasprecioService: GasprecioService,
    private sharedService: SharedService,
    private router: Router
  ) {
    this.event$ = this.router.events.subscribe((event: NavigationEvent) => {
      if (event instanceof NavigationEnd) {
        this.route = /[^/]*$/.exec(event.url)[0];
      }
    });
    this.rol = localStorage.getItem('rol');
    this.idGroup = (this.rol === 'Dios') ? localStorage.getItem('group') || '60afa99655f4ee369d1df409' : localStorage.getItem('group');
    this.showRendichicas = this.idGroup === '615efe30b318ce63b8971986' ? true : false;
    this.idStation = localStorage.getItem('idStation');
    this.productType$ = this.sharedService.sharedProductTypeTotal.subscribe(productType => {
      if (this.productType !== productType) {
        this.productType = productType;
        if (this.reqst > 1) {
           this.v2 ? this.setDataV2() : this.setData();
        }
      }
    });

    this.idGroup$ = sharedService.sharedGroup.subscribe((idGroup: string) => {
      if (idGroup !== this.idGroup) {
        this.idGroup = idGroup;
        this.showRendichicas = this.idGroup === '615efe30b318ce63b8971986' ? true : false;
        if (this.reqst > 0) {
          this.zoneSelected = '';
          this.scheduleLoad();
        }
      }
    });

    this.idStation$ = sharedService.sharedStation.subscribe((station: string) => {
      if(station !== this.idStation && station) {
        this.idStation = station;
        if (this.reqst > 0) {
          this.scheduleLoad();
        }
      }
    });

    this.zoneSelected$ = sharedService.sharedZoneDashboard.subscribe((zone: string) => {
      if (zone === 'Total') {
        this.zoneSelected = null;
        if (zone !== this.zoneSelected) {
          this.scheduleLoad();
        }
      } else {
        if (zone !== this.zoneSelected) {
          this.zoneSelected = zone;
          this.scheduleLoad();
        }
      }
    });

    this.period$ = this.sharedService.sharedPeriodDashboard.subscribe(period => {
      if (period !== this.period) {
        this.period = period;
        if (this.reqst > 0) {
          this.scheduleLoad();
        }
      }
    });

    this.days$ = this.sharedService.sharedDaysDashboard.subscribe(days => {
      if (days !== this.days) {
        this.days = days;
        if (this.reqst > 0) {
          this.scheduleLoad();
        }
      }
    });

    this.weeks$ = this.sharedService.sharedWeeksAgo.subscribe(weeks => {
      if (weeks !== this.weeks) {
        this.weeks = weeks;
        if (this.reqst > 0) {
          this.scheduleLoad();
        }
      }
    });

    this.months$ = this.sharedService.sharedMonthsAgo.subscribe(months => {
      if (months !== this.months) {
        this.months = months;
        if (this.reqst > 0) {
          this.scheduleLoad();
        }
      }
    });

    this.importants$ = sharedService.sharedImportants.subscribe((importants: string) => {
      if (this.importants !== importants) {
        this.importants = importants;
        if (this.reqst > 0) {
          this.scheduleLoad();
        }
      }
    });

    this.selectedCluster$ = sharedService.sharedSelectedComplementClusters.subscribe((selectedCluster: any) => {
      if (selectedCluster !== this.selectedCluster) {
        this.selectedCluster = selectedCluster;
        if (this.reqst > 0) {
          this.scheduleLoad();
        }
      }
    });

    this.selectedCluster2$ = sharedService.sharedSelectedComplementClusters2.subscribe((selectedCluster2: any) => {
      if (selectedCluster2 !== this.selectedCluster2) {
        this.selectedCluster2 = selectedCluster2;
        if (this.reqst > 0) {
          this.scheduleLoad();
        }
      }
    });

    this.selectedCluster3$ = sharedService.sharedSelectedComplementClusters3.subscribe((selectedCluster3: any) => {
      if (selectedCluster3 !== this.selectedCluster3) {
        this.selectedCluster3 = selectedCluster3;
        if (this.reqst > 0) {
          this.scheduleLoad();
        }
      }
    });

    this.selectedCluster4$ = sharedService.sharedSelectedComplementClusters4.subscribe((selectedCluster4: any) => {
      if (selectedCluster4 !== this.selectedCluster4) {
        this.selectedCluster4 = selectedCluster4;
        if (this.reqst > 0) {
          this.scheduleLoad();
        }
      }
    });
  }

  // Filters often change together; batch them into one request.
  private scheduleLoad(): void {
    clearTimeout(this.loadTimer);
    this.loadTimer = setTimeout(() => this.getDashboardEarning(), 50);
  }

  ngOnInit() {
    this.scheduleLoad();
  }

  ngOnDestroy(): void {
    clearTimeout(this.loadTimer);
    this.request$?.unsubscribe();
    this.days$.unsubscribe();
    this.event$.unsubscribe();
    this.idGroup$.unsubscribe();
    this.importants$.unsubscribe();
    this.months$.unsubscribe();
    this.period$.unsubscribe();
    this.productType$.unsubscribe();
    this.selectedCluster$.unsubscribe();
    this.selectedCluster2$.unsubscribe();
    this.selectedCluster3$.unsubscribe();
    this.selectedCluster4$.unsubscribe();
    this.weeks$.unsubscribe();
    this.zoneSelected$.unsubscribe();
  }

  getDashboardEarning() {
    this.reqst = 1;
    let typeValue = 'value';
    const periodMap = {
      'day': this.days,
      'week': this.weeks,
      'month': this.months
    };
    const n = periodMap[this.period];
    typeValue = (typeof n === 'number') ? 'value' : 'date';

    if(this.importants !== undefined) {
      const url = this.station ?
        (this.v2 ? this.gasprecioService.getStationDashboardV2Data(this.idGroup, this.idStation, this.period, n) :
        this.gasprecioService.getDashboardEarningStation(this.period, typeValue, n)) :
        this.gasprecioService.getDashboardEarning(this.idGroup, this.zoneSelected, this.period, this.importants, typeValue, n, this.selectedCluster, this.selectedCluster2, this.selectedCluster3, this.selectedCluster4);
      this.request$?.unsubscribe();
      this.request$ = url.subscribe({
        next: (data: any) => {
          if(this.v2){
            this.fullData = data;
            this.setDataV2();
          }else {
            const info = data;
            // Eliminar duplicados cuando el periodo es 'week'
            if (this.period === 'week') {
              this.earning = this.gasprecioService.removeDuplicateWeeks(info['earning'] || []);
              this.earningDif = this.gasprecioService.removeDuplicateWeeks(info['earning_comparison'] || []);
            } else {
              this.earning = info['earning'];
              this.earningDif = info['earning_comparison'];
            }
            this.setData();
          }
        }, complete: () => {
          this.reqst = 2;
        }, error: () => {
          this.reqst = 3;
        }
      });
    } else {
      this.reqst = 2;
    }
  }

  setDataV2() {
    this.reqst = 1;
    const color = this.gasprecioService.getColorString(this.gasprecioService.colorsProducts[this.gasprecioService.getProductTypeIndex(this.productType)]);
    const colorLight = this.gasprecioService.getColorRGBAString(this.gasprecioService.colorsProducts[this.gasprecioService.getProductTypeIndex(this.productType)]);

    const earningData = this.fullData.map(d =>
      d.products?.[this.productType]?.earnings ?? null
    );

    const minVolume = Math.min(
      ...earningData.filter(v => v !== null && v !== 0).map(v => +v)
    );

    const earningDif = this.fullData.map(d =>
      d.products?.[this.productType]?.earning_difference ?? null
    );

    const lineXaxisLegendGenerator = {
      day:  (v: any) => this.gasprecioService.parseDateDM(v.date.formatted),
      week: (v: any) => v.date.label,
      month:(v: any) => this.gasprecioService.parseDateM(v.date.formatted)
    };

    const lineXaxisLegend = this.fullData.map(lineXaxisLegendGenerator[this.period]);
    const xAxis = Array.isArray(this.chartOptions.xAxis)? this.chartOptions.xAxis[0]: this.chartOptions.xAxis;
    xAxis.categories = lineXaxisLegend;
    const numberLabels = xAxis.categories.length;
    const borderW = numberLabels >= 90 ? 0.4 : 2;

    let purchaseChartData;

    if (this.productType === 'total') {
      this.showScale = true;

      const productTypes = ['regular', 'premium', 'diesel'];

      const colors = productTypes.map(type =>this.gasprecioService.getColorString(this.gasprecioService.colorsProducts[this.gasprecioService.getProductTypeIndex(type)]));
      const colorLights = productTypes.map(type => this.gasprecioService.getColorRGBAString(this.gasprecioService.colorsProducts[this.gasprecioService.getProductTypeIndex(type)]));

      if (!this.showRendichicas || this.showColor) {
        purchaseChartData = productTypes.map((type, index) => ({
          name: this.gasprecioService.capitalizeFirstLetter(type),
          type: 'column',
          data: this.fullData.map(d => d.products?.[type]?.earnings ?? null),
          color: this.showColor ? colorLights[index] : '#96d6ff',
          borderColor: this.showColor ? colors[index] : '#96d6ff',
          borderWidth: borderW,
          yAxis: 0,
          stack: 'total',
          tooltip: {
            pointFormatter: function () {
              return `<b>${this.series.name}: $${this.y.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</b>`;
            }
          }
        }));
      } else {
        const totalData = this.fullData.map(d =>
          productTypes.reduce(
            (sum, type) => sum + (+d.products?.[type]?.earnings || 0),
            0
          )
        );
        purchaseChartData = [{
          name: 'Total',
          type: 'column',
          data: totalData,
          color: '#96d6ff',
          borderColor: '#96d6ff',
          borderWidth: borderW,
          yAxis: 0,
          stack: 'total',
          tooltip: {
            pointFormatter: function () {
              return `<b>${this.series.name}: $${this.y.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</b>`;
            }
          }
        }];
      }
    } else {
      purchaseChartData = [{
        name: 'Utilidad Bruta',
        type: 'column',
        data: earningData.map(v => v == null ? null : +v),
        color: colorLight,
        borderColor: color,
        borderWidth: borderW,
        yAxis: 0,
        tooltip: {
          pointFormatter: function () {
            return `<b>${this.series.name}: $${this.y.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</b>`;
          }
        }
      }];
    }

    if (!earningDif.some(v => v != null)) {
      this.chartOptions.annotations = [];
    }

    this.chartOptions.yAxis[0].min = this.showScale ? 0 : minVolume;
    this.chartOptions.series = purchaseChartData;
    setTimeout(() => {
      this.reqst = 2;
    }, 100);
  }

  setData() {
    this.reqst = 1;
    const color = this.gasprecioService.getColorString(this.gasprecioService.colorsProducts[this.gasprecioService.getProductTypeIndex(this.productType)]);
    const colorLight = this.gasprecioService.getColorRGBAString(this.gasprecioService.colorsProducts[this.gasprecioService.getProductTypeIndex(this.productType)]);

    const minVolume = Math.min(...this.earning
      .map((comp: any) => +comp[this.productType])
      .filter((value: number) => value !== null && value !== 0)
    );

    let purchaseChartData: any;

    const lineXaxisLegendGenerator = {
      day: (v: any) => this.gasprecioService.parseDateDM(v.date),
      week: (v: any) => v.date_alias,
      month: (v: any) => this.gasprecioService.parseDateM(v.date)
    };

    const lineXaxisLegend = this.earning.map(lineXaxisLegendGenerator[this.period]);
    this.chartOptions['xAxis']['categories'] = lineXaxisLegend;
    let numberLabels = this.chartOptions['xAxis']['categories'].length;
    const borderW = numberLabels >= 90 ? .4 : 2;
    if (this.productType === 'total') {
      this.showScale = true;
      const colors = [
        this.gasprecioService.getColorString(this.gasprecioService.colorsProducts[this.gasprecioService.getProductTypeIndex('regular')]),
        this.gasprecioService.getColorString(this.gasprecioService.colorsProducts[this.gasprecioService.getProductTypeIndex('premium')]),
        this.gasprecioService.getColorString(this.gasprecioService.colorsProducts[this.gasprecioService.getProductTypeIndex('diesel')])
      ];

      const colorLights = [
        this.gasprecioService.getColorRGBAString(this.gasprecioService.colorsProducts[this.gasprecioService.getProductTypeIndex('regular')]),
        this.gasprecioService.getColorRGBAString(this.gasprecioService.colorsProducts[this.gasprecioService.getProductTypeIndex('premium')]),
        this.gasprecioService.getColorRGBAString(this.gasprecioService.colorsProducts[this.gasprecioService.getProductTypeIndex('diesel')])
      ];

      const productTypes = ['regular', 'premium', 'diesel'];

      if(!this.showRendichicas || this.showColor){
        purchaseChartData = productTypes.map((type, index) => ({
          name: this.gasprecioService.capitalizeFirstLetter(type),
          type: 'column',
          data: this.earning.map((v: any) => {
            if (v[type] === null) {
              return null; // Devuelve null si el valor es null
            } else {
              return +v[type]; // Devuelve el valor convertido a número
            }
          }),
          color: this.showColor ? colorLights[index] : '#96d6ff',
          borderColor: this.showColor ? colors[index] : '#96d6ff',
          borderWidth: borderW,
          yAxis: 0,
          stack: 'total',
          tooltip: {
            pointFormatter: function () {
              return '<b>' + this.series.name + ': $' + this.y.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '</b>';
            }
          }
        }));
      }else{
        const totalData = this.earning.map((v: any) =>
          productTypes.reduce((sum, type) => sum + (v[type] ?? 0), 0)
        );
        purchaseChartData = [{
          name: 'Total',
          type: 'column',
          data: totalData,
          color: '#96d6ff',
          borderColor: '#96d6ff',
          borderWidth: borderW,
          yAxis: 0,
          stack: 'total',
          tooltip: {
            pointFormatter: function () {
              return '<b>' + this.series.name + ': ' + this.y.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' lts.</b>';
            }
          }
        }];
      }
    } else {
      purchaseChartData = [{
        name: 'Utilidad Bruta',
        type: 'column',
        data: this.earning.map((v: any) => {
          if (v[this.productType] === null) {
            return null; // Devuelve null si el valor es null
          } else {
            return +v[this.productType]; // Devuelve el valor convertido a número
          }
        }),
        color: colorLight,
        borderColor: color,
        borderWidth: borderW,
        yAxis: 0,
        tooltip: {
          pointFormatter: function () {
            return '<b>' + this.series.name + ': $' + this.y.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '</b>';
          }
        }
      }];
    }

    let diffPct2, diffPct1, diff2, diff1, labelDiff2, labelDiff1;

    if (this.earningDif.length > 0) {
      diffPct2 = this.earningDif[1]['diff_pct_' + this.productType] !== null ? this.earningDif[1]['diff_pct_' + this.productType].toFixed(0) : '-';
      diffPct1 = this.earningDif[2]['diff_pct_' + this.productType] !== null ? this.earningDif[2]['diff_pct_' + this.productType].toFixed(0) : '-';
      diff2 = this.earningDif[1]['diff_' + this.productType] !== null ? this.earningDif[1]['diff_' + this.productType].toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '-';
      diff1 = this.earningDif[2]['diff_' + this.productType] !== null ? this.earningDif[2]['diff_' + this.productType].toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '-';
      labelDiff2 = this.period === 'month' ? moment().subtract(1, 'month').tz('America/Mexico_City').format('MMMM') : this.chartOptions['xAxis']['categories'][numberLabels - 2];
      labelDiff1 = this.period === 'month' ? moment().tz('America/Mexico_City').format('MMMM') : this.chartOptions['xAxis']['categories'][numberLabels - 1];
      let pos1 = numberLabels - 1;
      let pos2 = numberLabels - 2;

      let typeValue = 'value';
      const periodMap = {
        'day': this.days,
        'week': this.weeks,
        'month': this.months
      };
      const n = periodMap[this.period];
      typeValue = (typeof n === 'number') ? 'value' : 'date';
      if (typeValue === 'value') {
        if (this.period === 'week' && this.weeks === 26) {
          pos2 = numberLabels - 3;
          pos1 = numberLabels - 1;
        } else if (this.period === 'week' && this.weeks === 52) {
          pos2 = numberLabels - 4;
        } else if (this.period === 'week' && this.weeks === 104) {
          pos2 = numberLabels - 8;
        } else if (this.period === 'week' && this.weeks === 156) {
          pos2 = numberLabels - 14;
        }
      } else if (typeValue === 'date') {
        if (numberLabels < 80) {
          pos2 = numberLabels - 6;
        } else if (numberLabels < 150) {
          pos2 = numberLabels - 11;
          pos1 = numberLabels - 3;
        } else if (numberLabels < 180) {
          pos2 = numberLabels - 15;
          pos1 = numberLabels - 4;
        }
      }

      if (this.period === 'month' && (this.months === 18 || this.months === 24)) {
        pos2 = numberLabels - 4;
      } else if (this.period === 'month' && this.months === 30) {
        pos2 = numberLabels - 4;
      } else if (this.period === 'month' && this.months === 36) {
        pos2 = numberLabels - 5;
      }

      const annotations: any = [
        {
          draggable: '',
          labelOptions: {
            backgroundColor: '#CCCCCC',
            verticalAlign: 'top',
            align: 'center'
          },
          labels: [
            {
              point: {
                xAxis: 0,
                yAxis: 1,
                x: pos2, // Índice de la penúltima columna (0-indexed)
                y: 0 // Valor de la penúltima columna
              },
              crop: false,
              overflow: 'justify',
              allowOverlap: true,
              distance: 1,
              shape: 'rect',
              text: `<div style="font-size: .5vw;"><strong>${labelDiff2}<br>$ ${diff2}<br>${diffPct2} %</strong></div>`
            },
            {
              point: {
                xAxis: 0,
                yAxis: 1,
                x: pos1, // Índice de la penúltima columna (0-indexed)
                y: 0 // Valor de la penúltima columna
              },
              crop: false,
              overflow: 'justify',
              distance: 1,
              allowOverlap: true,
              shape: 'rect',
              text: `<div style="font-size: .5vw;"><strong>${labelDiff1}<br>$ ${diff1}<br>${diffPct1} %</strong></div>`
            }
          ]
        }];
      this.chartOptions.annotations = this.showTooltip ? annotations : [];
    } else {
      this.chartOptions.annotations = []
    }

    this.chartOptions['yAxis'][0]['min'] = this.showScale ? 0 : minVolume;
    this.chartOptions.series = purchaseChartData;
    setTimeout(() => {
      this.reqst = 2;
    }, 100);
  }

  generateImageChart() {
    const canvas6: any = document.getElementById('mychart6');
    const imgData6 = canvas6.toDataURL('image/png');
    this.sharedService.nextImgData6 = imgData6;
  }

  toggleColors(newValue: boolean){
    this.showColor = !this.showColor;
    this.changeColor = newValue;
    setTimeout(() => {
      this.setData();
    }, 100);
  }
}




